import { unionBy } from 'lodash-es';

export const CLIENT = 'ciam-role-Client';
export const CLIENT_ADMIN = 'ciam-role-ClientAdmin';
export const CRUX_ADMIN = 'ciam-role-CruxAdmin';
export const CRUX_OPERATOR = 'ciam-role-CruxOperator';
export const CRUX_STEWARD = 'ciam-role-CruxSteward';
export const DATA_ENGINEER = 'ciam-role-CruxDataEngineer';

export const USER_ROLE_OPTIONS = [
  { label: 'Client', value: CLIENT },
  { label: 'Client Admin', value: CLIENT_ADMIN },
];

export const CRUX_ADMIN_USER_ROLE_OPTIONS = [
  { label: 'Crux Admin', value: CRUX_ADMIN },
  { label: 'Crux Data Engineer', value: DATA_ENGINEER },
  { label: 'Crux Operator', value: CRUX_OPERATOR },
  { label: 'Crux Steward', value: CRUX_STEWARD },
  ...USER_ROLE_OPTIONS,
];

export const ORG_ADMIN_WIZARD_ROLE_OPTIONS = [
  { label: 'Client Admin', value: CLIENT_ADMIN },
  { label: 'Crux Admin', value: CRUX_ADMIN },
];

export const USER_ROLE_MAP = unionBy(CRUX_ADMIN_USER_ROLE_OPTIONS, 'value').reduce((result, { label, value }) => {
  return {
    ...result,
    [value]: label,
  };
}, {});

export const USER_ROLE_GROUPS = {
  client: 'client',
  cruxer: 'cruxer',
};
